import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import BaseURL from '../assets/contants/BaseURL';
import Header from '../components/header';
import { ChromePicker } from 'react-color';
// import { color } from 'highcharts';
// import { Colors } from 'chart.js';

const MachineList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchMeter, setSearchMeter] = useState('');
  const [searchEditMeter, setSearchEditMeter] = useState('');
  const [checkedItems, setCheckedItems] = useState({});
  const [machines, setMachines] = useState([]);
  const [meters, setMeters] = useState([]);
  const [filteredMeter, setFilteredMeter] = useState([]);
  const [newMachine, setNewMachine] = useState({
    machine_name: '',
    machine_id: '',
    line: '',
    manufacture: '',
    meter_list: [],
    product_list: [],
    color: '',
    weight_unit: '',
    target_poured: '',
    target_melted: '',
    from_time: '',
    to_time: '',
    target_sands: ''
  });
  const [editMachine, setEditMachine] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(machines.length / itemsPerPage);
  const paginatedMachines = machines.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const [selectedMeters, setSelectedMeters] = useState([]);
  const [addedMeters, setAddedMeters] = useState([]);
  const addMachineModalRef = useRef();
  const editMachineModalRef = useRef();
  const deleteModalRef = useRef();
  const [originalMachines, setOriginalMachines] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [validationMessages, setValidationMessages] = useState({
    machine_name: '',
    machine_id: '',
    weight_unit: '',
    color: '',
    from_time: '',
    to_time: '',
  });
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [addedProducts, setAddedProducts] = useState([]);
  const [searchProduct, setSearchProduct] = useState('');
  const [searchEditProduct, setSearchEditProduct] = useState('');
  const [filteredEditProducts, setFilteredEditProducts] = useState([]);
  const [productTargets, setProductTargets] = useState({});
  const [usersData, setUsersData] = useState({});
  const [addsearchTerm, setAddSearchTerm] = useState('');
  const [userList, setUserList] = useState([]);
  const [editsearchTerm, setEditSearchTerm] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BaseURL}meters/products/`);
        setProducts(response.data);
        setFilteredProducts(response.data);
      } catch (err) {
        console.error('Error fetching products:', err);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    if (searchProduct === '') {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(product =>
        product.product_name.toLowerCase().includes(searchProduct.toLowerCase()) ||
        product.product_id.toLowerCase().includes(searchProduct.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
  }, [searchProduct, products]);

  const handleProductSearchChange = (e) => {
    setSearchProduct(e.target.value);
  };

  const handleAddProduct = (product) => {
    if (!addedProducts.some(p => p.id === product.id)) {
      setAddedProducts([...addedProducts, product]);
    }
  };

  const handleRemoveProduct = (productId) => {
    setAddedProducts(prev => prev.filter(product => product.id !== productId));
    setProductTargets(prev => {
      const newTargets = { ...prev };
      delete newTargets[productId];
      return newTargets;
    });
  };

  useEffect(() => {
    if (searchEditProduct === '') {
      setFilteredEditProducts(products);
    } else {
      const filtered = products.filter(product =>
        product.product_name.toLowerCase().includes(searchEditProduct.toLowerCase()) ||
        product.product_id.toLowerCase().includes(searchEditProduct.toLowerCase())
      );
      setFilteredEditProducts(filtered);
    }
  }, [searchEditProduct, products]);

  const handleProductTargetChange = (productId, value) => {
    setProductTargets(prev => ({
      ...prev,
      [productId]: value
    }));
  };

  // const pouredMeltedRef = useRef(null);
  // const sandsRef = useRef(null);

  // useEffect(() => {
  //   if (newMachine.weight_unit === 'tons' && pouredMeltedRef.current) {
  //     pouredMeltedRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   } else if (newMachine.weight_unit === 'sands' && sandsRef.current) {
  //     sandsRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   }
  // }, [newMachine.weight_unit]);




  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  // const handleMeterSelection = (e) => {
  //   const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
  //   setSelectedMeters(selectedOptions);
  //   setAddedMeters(selectedOptions);
  //   setNewMachine(prevMachine => ({
  //     ...prevMachine,
  //     meter_list: selectedOptions,
  //   }));
  // };


  const fetchMachines = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/machine/`);
      const sortedMachines = response.data.sort((a, b) => new Date(b.create_date_time) - new Date(a.create_date_time));
      setMachines(sortedMachines);
      setOriginalMachines(sortedMachines);
    } catch (error) {
      console.error('Error fetching machine data:', error);
    }
  };


  const fetchMeters = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/energymeters/`);
      setMeters(response.data);
      setFilteredMeter(response.data);
    } catch (error) {
      console.error('Error fetching meters:', error);
    }
  };


  useEffect(() => {
    fetchMachines();
    fetchMeters();
  }, []);

  const handleAddMachine = async () => {
    setValidationMessages({
      machine_name: '',
      machine_id: '',
      color: '',
      from_time: '',
      to_time: '',
      target_diesel: '',
      target_lpg: ''
    });

    let isValid = true;

    if (!newMachine.machine_name) {
      setValidationMessages((prev) => ({ ...prev, machine_name: 'Machine Name is required.' }));
      isValid = false;
    }

    if (!newMachine.machine_id) {
      setValidationMessages((prev) => ({ ...prev, machine_id: 'Machine ID is required.' }));
      isValid = false;
    } else {
      const isDuplicate = machines.some((machine) => machine.machine_id === newMachine.machine_id);
      if (isDuplicate) {
        setValidationMessages((prev) => ({ ...prev, machine_id: 'Machine details with this Machine ID already exist.' }));
        isValid = false;
      }
    }

    if (!newMachine.color) {
      setValidationMessages((prev) => ({ ...prev, color: 'Color is required.' }));
      isValid = false;
    }

    if (!newMachine.from_time) {
      setValidationMessages((prev) => ({ ...prev, from_time: 'From Time is required.' }));
      isValid = false;
    }

    if (!newMachine.to_time) {
      setValidationMessages((prev) => ({ ...prev, to_time: 'To Time is required.' }));
      isValid = false;
    }

    if (newMachine.diesel && (newMachine.target_diesel === null || newMachine.target_diesel === '' || isNaN(newMachine.target_diesel))) {
      setValidationMessages((prev) => ({ ...prev, target_diesel: 'Diesel target is required when Diesel is selected.' }));
      isValid = false;
    }

    if (newMachine.lpg && (newMachine.target_lpg === null || newMachine.target_lpg === '' || isNaN(newMachine.target_lpg))) {
      setValidationMessages((prev) => ({ ...prev, target_lpg: 'LPG target is required when LPG is selected.' }));
      isValid = false;
    }

    if (!isValid) return;

    try {
      const updatedMeterList = selectedMeters.map((meter) => meter.id).filter((id) => id !== null);
      const updatedProductList = addedProducts.map((product) => product.id);
      const targets = {};
      
      addedProducts.forEach(product => {
        targets[product.product_name] = productTargets[product.id] || 0;
      });
      const machineData = {
        ...newMachine,
        target_poured: newMachine.target_poured === '' ? 0 : Number(newMachine.target_poured),
        target_melted: newMachine.target_melted === '' ? 0 : Number(newMachine.target_melted),
        target_sands: newMachine.target_sands === '' ? 0 : Number(newMachine.target_sands),
        target_diesel: newMachine.diesel ? Number(newMachine.target_diesel) || 0 : null,
        target_lpg: newMachine.lpg ? Number(newMachine.target_lpg) || 0 : null,
        meter_list: updatedMeterList,
        product_list: updatedProductList,
        targets: targets,
        user_list: userList,
        diesel: newMachine.diesel || false,
        lpg: newMachine.lpg || false
      };

      console.log("Machine Data being sent:", machineData);

      await axios.post(`${BaseURL}meters/machine/`, machineData);
      fetchMachines();
      setNewMachine({
        machine_name: '',
        machine_id: '',
        line: '',
        manufacture: '',
        meter_list: [],
        product_list: [],
        color: '',
        weight_unit: '',
        target_poured: '',
        target_melted: '',
        target_sands: '',
        from_time: '',
        to_time: '',
        diesel: false,
        lpg: false,
        target_diesel: null,
        target_lpg: null
      });
      setSelectedMeters([]);
      setAddedMeters([]);
      setAddedProducts([]);
      setProductTargets({});
      setUserList([]);
      setModalOpen(false);
      setSuccessMessage('Machine added successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error adding machine:', error);
    }
  };

  const fetchMachineById = async (id) => {
    try {
      const response = await axios.get(`${BaseURL}meters/machine/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching machine:', error);
      return null;
    }
  };

  const handleEditButtonClick = async (machine) => {
    try {
      const machineData = await fetchMachineById(machine.id);
      if (!machineData) return;

      console.log("Fetched machine data:", machineData);

      setEditMachine({
        id: machineData.id,
        machine_name: machineData.machine_name,
        machine_id: machineData.machine_id,
        line: machineData.line,
        manufacture: machineData.manufacture,
        meter_list: machineData.meter_list || [],
        product_list: machineData.product_list || [],
        color: machineData.color,
        weight_unit: machineData.weight_unit,
        target_poured: machineData.target_poured,
        target_melted: machineData.target_melted,
        target_sands: machineData.target_sands,
        from_time: machineData.from_time,
        to_time: machineData.to_time,
        targets: machineData.targets || {},
        diesel: machineData.diesel || false,
        lpg: machineData.lpg || false,
        target_diesel: machineData.target_diesel || null,
        target_lpg: machineData.target_lpg || null  
      });
      setUserList(machineData.user_list || []);

      setEditModalOpen(true);
      setSearchEditProduct('');
      setSearchEditMeter('');
    } catch (error) {
      console.error('Error handling edit:', error);
    }
  };

  useEffect(() => {
    if (searchEditProduct === '') {
      setFilteredEditProducts(products);
    } else {
      const filtered = products.filter(product =>
        product.product_name.toLowerCase().includes(searchEditProduct.toLowerCase()) ||
        product.product_id.toLowerCase().includes(searchEditProduct.toLowerCase())
      );
      setFilteredEditProducts(filtered);
    }
  }, [searchEditProduct, products]);

  const handleEditTimeChange = (type, timeValue) => {
    if (!timeValue) {
      if (type === 'from') {
        setEditMachine(prev => ({ ...prev, from_time: '' }));
      } else {
        setEditMachine(prev => ({ ...prev, to_time: '' }));
      }
      return;
    }

    if (type === 'from') {
      setEditMachine(prev => ({ ...prev, from_time: timeValue }));
    } else {
      setEditMachine(prev => ({ ...prev, to_time: timeValue }));
    }
  };

  useEffect(() => {
    if (editMachine) {
      setSelectedMeters(editMachine.meter_list);
    }
  }, [editMachine])

  const handleEditMachine = async () => {
    setValidationMessages({
      machine_name: '',
      machine_id: '',
    });

    let isValid = true;

    if (!editMachine.machine_name) {
      setValidationMessages((prev) => ({ ...prev, machine_name: 'Machine Name is required.' }));
      isValid = false;
    }

    if (!editMachine.machine_id) {
      setValidationMessages((prev) => ({ ...prev, machine_id: 'Machine ID is required.' }));
      isValid = false;
    } else {

      const isDuplicate = machines.some(
        (machine) => machine.machine_id === editMachine.machine_id && machine.id !== editMachine.id
      );

      if (isDuplicate) {
        setValidationMessages((prev) => ({ ...prev, machine_id: 'Machine details with this Machine ID already exist.' }));
        isValid = false;
      }
    }

    if (!isValid) return;
    try {
      const updatedUserList = userList || [];
      console.log('Sending data for editing:', {
        ...editMachine,
        meter_list: editMachine.meter_list,
        product_list: editMachine.product_list,
      });

      await axios.put(`${BaseURL}meters/machine/${editMachine.id}/`, {
        ...editMachine,
        meter_list: editMachine.meter_list,
        product_list: editMachine.product_list,
        user_list: updatedUserList,
        target_diesel: editMachine.diesel ? Number(editMachine.target_diesel) || 0 : null,
        target_lpg: editMachine.lpg ? Number(editMachine.target_lpg) || 0 : null,
      });
      fetchMachines();
      setEditMachine(null);
      setEditModalOpen(false);
      setSuccessMessage('Machine updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error editing machine:', error);
    }
  };

  const handleDeleteMachines = async () => {
    const idsToDelete = Object.keys(checkedItems).filter((id) => checkedItems[id]);
    if (idsToDelete.length === 0) {
      setDeleteModalOpen(false);
      return;
    }

    try {
      for (const id of idsToDelete) {
        await axios.delete(`${BaseURL}meters/machine/${id}/`);
      }
      fetchMachines();
      setCheckedItems({});
      setSuccessMessage('Selected machines deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      console.error('Error deleting machines:', error);
    } finally {
      setDeleteModalOpen(false);
    }
  };


  const handleSearch = () => {
    if (searchTerm.trim() === '') {
      setMachines(originalMachines);
    } else {
      const results = originalMachines.filter((machine) => {
        const machineNameMatch = machine.machine_name.toLowerCase().includes(searchTerm.toLowerCase());
        const machineIdMatch = machine.machine_id.toLowerCase().includes(searchTerm.toLowerCase());
        const meterListMatch = machine.meter_list
          .map((meterId) => meters.find((meter) => meter.id === meterId)?.meter_id)
          .some((meterId) => meterId && meterId.toLowerCase().includes(searchTerm.toLowerCase()));

        return machineNameMatch || machineIdMatch || meterListMatch;
      });
      setMachines(results);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  const handleCheckboxChange = (id) => {
    setCheckedItems((prev) => {
      const newCheckedItems = {
        ...prev,
        [id]: !prev[id],
      };
      return newCheckedItems;
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const newCheckedItems = {};
    machines.forEach((machine) => {
      newCheckedItems[machine.id] = isChecked;
    });
    setCheckedItems(newCheckedItems);
  };

  const handleRemoveMeter = (meterId) => {
    setAddedMeters(prev => prev.filter(meter => meter.meter_id !== meterId));
    setSelectedMeters(prev => prev.filter(meter => meter.meter_id !== meterId));
  };

  const handleAddMeter = (meter) => {
    if (!addedMeters.some(m => m.meter_id === meter.meter_id)) {
      setAddedMeters(prevAddedMeters => [...prevAddedMeters, meter]);
      setSelectedMeters(prevSelectedMeters => [...prevSelectedMeters, meter]);
    } else {
      console.log(`Meter ID ${meter.meter_id} is already added.`);
    }
  };


  const handlemeterSearch = () => {
    if (searchMeter.trim() === '') {
      setFilteredMeter(meters);
    } else {
      const filtered = meters.filter((meter) =>
        meter.meter_id.toLowerCase().includes(searchMeter.toLowerCase()) ||
        meter.meter_name.toLowerCase().includes(searchMeter.toLowerCase())
      );
      setFilteredMeter(filtered);
    }
  };

  const handlemeterSearchChange = (e) => {
    setSearchMeter(e.target.value);
  };

  useEffect(() => {
    handlemeterSearch();
  }, [searchMeter, meters]);

  const addMeter = (meterId) => {
    if (!editMachine.meter_list.includes(meterId)) {
      setEditMachine({
        ...editMachine,
        meter_list: [...editMachine.meter_list, meterId],
      });
    }
  };

  const handleMeterSearchChange = (e) => {
    setSearchEditMeter(e.target.value);
  };

  const filteredMeters = meters.filter((meter) =>
    meter.meter_id.toLowerCase().includes(searchEditMeter.toLowerCase())
  );

  const inputStyle = {
    padding: '8px',
    borderRadius: '10px',
    border: '1px solid #ced4da',
    width: '100%',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const handleTimeChange = (type, timeValue) => {
    if (!timeValue) {
      if (type === 'from') {
        // setAddFromTime(null);
        setNewMachine(prev => ({ ...prev, from_time: '' }));
      } else {
        // setAddToTime(null);
        setNewMachine(prev => ({ ...prev, to_time: '' }));
      }
      return;
    }

    if (type === 'from') {
      setNewMachine(prev => ({ ...prev, from_time: timeValue }));
    } else {
      setNewMachine(prev => ({ ...prev, to_time: timeValue }));
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const usersResponse = await axios.get(`${BaseURL}Userauth/userdetail/`, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });

        const usersMap = usersResponse.data.reduce((map, obj) => {
          if (obj.usermod && obj.usermod.username) {
            map[obj.user_id] = obj.usermod.username;
          } else {
            console.error('Missing usermod or username:', obj);
          }
          return map;
        }, {});

        setUsersData(usersMap);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchUsers();
  }, []);

  const handleAddUser = (userId) => {
    if (!userList.includes(userId)) {
      setUserList([...userList, userId]);
    }
  };

  const handleRemoveUser = (userId) => {
    setUserList(userList.filter(id => id !== userId));
  };

  const filteredUsers = Object.entries(usersData).filter(([userId, username]) =>
    username.toLowerCase().includes(addsearchTerm.toLowerCase())
  );

  const filterededitUsers = Object.entries(usersData).filter(([userId, username]) =>
    username.toLowerCase().includes(editsearchTerm.toLowerCase())
  );

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="DEPARTMENT LIST" />
      </div>

      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        margin: '20px auto',
        maxWidth: '1000px',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
            <input
              type="text"
              placeholder="Search"
              style={{
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                flex: '1',
                marginRight: '10px',
              }}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <FontAwesomeIcon
              icon={faSearch}
              style={{ color: '#007acc', cursor: 'pointer' }}
              onClick={handleSearch}
            />
          </div>

          <div style={{ marginLeft: 'auto' }}>
            <button
              style={{
                padding: '10px 15px',
                marginRight: '10px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
              onClick={() => {
                const idsToDelete = Object.keys(checkedItems).filter((id) => checkedItems[id]);
                if (idsToDelete.length > 0) {
                  setDeleteModalOpen(true);
                }
              }}
            >
              <FontAwesomeIcon icon={faTrash} style={{ marginRight: '5px' }} />
              Delete
            </button>
            <button
              style={{
                padding: '10px 15px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
              onClick={() => setModalOpen(true)}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
              Add
            </button>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        {successMessage && (
          <div style={{
            padding: '10px',
            borderRadius: '5px',
            backgroundColor: '#4CAF50',
            color: 'white',
            margin: '10px auto',
            width: 'fit-content',
          }}>
            {successMessage}
          </div>
        )}
      </div>

      <div style={{
        marginTop: '20px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '1000px',
        margin: '20px auto',
        marginBottom: '70px',
      }}>
        <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#007acc', color: 'white' }}>
            <tr>
              <th style={{ padding: '10px' }}>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={
                    machines.length > 0 &&
                    Object.keys(checkedItems).length === machines.length &&
                    Object.values(checkedItems).every((checked) => checked)
                  }
                />
              </th>
              <th style={{ padding: '10px' }}>S.No</th>
              <th style={{ padding: '10px' }}>Department Name</th>
              <th style={{ padding: '10px' }}>Department ID</th>
              <th style={{ padding: '10px' }}>Meter List</th>
              <th style={{ padding: '10px' }}>Product List</th>
              <th style={{ padding: '10px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedMachines.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                  No data available
                </td>
              </tr>
            ) : (
              paginatedMachines.map((machine, index) => {
                const meterInfo = machine.meter_list
                  .map((meterId) => {
                    const meter = meters.find((meter) => meter.id === meterId);
                    return meter ? `${meter.meter_name} - ${meter.meter_id}` : null;
                  })
                  .filter(Boolean);

                const productInfo = machine.product_list
                  .map((productId) => {
                    const product = products.find((product) => product.id === productId);
                    return product ? `${product.product_name} - ${product.product_id}` : null;
                  })
                  .filter(Boolean);

                return (
                  <tr key={machine.id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#ffffff' }}>
                    <td style={{ padding: '10px' }}>
                      <input
                        type="checkbox"
                        checked={checkedItems[machine.id] || false}
                        onChange={() => handleCheckboxChange(machine.id)}
                      />
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td style={{ padding: '10px', textAlign: 'left' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <span
                          style={{
                            width: '20px',
                            height: '20px',
                            minWidth: '20px',
                            minHeight: '20px',
                            backgroundColor: machine.color && machine.color !== '#FFFFFF' ? machine.color : '#007acc',
                            borderRadius: '50%',
                            border: '2px solid #fff',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            marginRight: '10px',
                            transition: 'transform 0.2s ease',
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                        />
                        <span>{machine.machine_name || '-'}</span>
                      </div>
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>{machine.machine_id}</td>
                    <td style={{ padding: '10px', textAlign: 'left', wordWrap: 'break-word' }}>
                      {meterInfo.length > 0
                        ? meterInfo.map((meter, index) => (
                          <span
                            key={index}
                            style={{
                              marginRight: index < meterInfo.length - 1 ? '10px' : '0',
                              padding: '5px',
                              border: '1px solid #ddd',
                              borderRadius: '5px',
                              display: 'inline-block',
                              whiteSpace: 'normal',
                              marginBottom: '5px',
                              backgroundColor: 'white'
                            }}
                          >
                            {meter}
                          </span>
                        ))
                        : '-'}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'left', wordWrap: 'break-word' }}>
                      {productInfo.length > 0
                        ? productInfo.map((product, index) => (
                          <span
                            key={index}
                            style={{
                              marginRight: index < productInfo.length - 1 ? '10px' : '0',
                              padding: '5px',
                              border: '1px solid #ddd',
                              borderRadius: '5px',
                              display: 'inline-block',
                              whiteSpace: 'normal',
                              marginBottom: '5px',
                              backgroundColor: 'white'
                            }}
                          >
                            {product}
                          </span>
                        ))
                        : '-'}
                    </td>
                    <td
                      style={{
                        padding: '10px',
                        color: 'blue',
                        cursor: 'pointer',
                        textAlign: 'center',
                      }}
                      onClick={() => handleEditButtonClick(machine)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>



        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: currentPage === 1 ? '#007acc' : '#007acc',
              color: currentPage === 1 ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              boxShadow: currentPage === 1 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
              fontSize: '12px',
            }}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              style={{
                margin: '0 5px',
                padding: '5px 10px',
                background: currentPage === i + 1 ? '#007acc' : 'linear-gradient(to right, #f7f7f7, #e0e0e0)',
                color: currentPage === i + 1 ? '#ffffff' : '#333333',
                border: '1px solid #ddd',
                borderRadius: '25px',
                cursor: 'pointer',
                fontSize: '12px',
              }}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              margin: '0 5px',
              padding: '5px 10px',
              background: currentPage === totalPages ? '#007acc' : '#007acc',
              color: currentPage === totalPages ? '#9e9e9e' : '#ffffff',
              border: 'none',
              borderRadius: '25px',
              cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
              boxShadow: currentPage === totalPages ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
              fontSize: '12px',
            }}
          >
            Next
          </button>
        </div>
      </div>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            ref={addMachineModalRef}
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              width: '60%',
              maxWidth: '600px',
              height: '480px',
              transition: 'all 0.3s ease',
              overflowX: 'auto'
            }}
          >
            <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Add New Department</h4>
            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      Department Name <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={newMachine.machine_name}
                      onChange={(e) => setNewMachine({ ...newMachine, machine_name: e.target.value })}
                      placeholder="Enter Machine Name"
                      style={{
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        width: '95%',
                      }}
                    />
                    {validationMessages.machine_name && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.machine_name}</div>
                    )}
                  </div>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      Department ID <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={newMachine.machine_id}
                      onChange={(e) => setNewMachine({ ...newMachine, machine_id: e.target.value })}
                      placeholder="Enter Machine ID (Unique)"
                      style={{
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        width: '95%',
                      }}
                    />
                    {validationMessages.machine_id && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.machine_id}</div>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      From Time <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="time"
                      value={newMachine.from_time || ''}
                      onChange={(e) => handleTimeChange('from', e.target.value)}
                      step="60"
                      style={inputStyle}
                      pattern="[0-9]{2}:[0-9]{2}"
                    />
                    {validationMessages.from_time && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.from_time}</div>
                    )}
                  </div>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      To Time <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="time"
                      value={newMachine.to_time || ''}
                      onChange={(e) => handleTimeChange('to', e.target.value)}
                      step="60"
                      style={inputStyle}
                      pattern="[0-9]{2}:[0-9]{2}"
                    />
                    {validationMessages.to_time && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.to_time}</div>
                    )}
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                  <div style={{ flex: '1' }}>
                    <label htmlFor="meters" style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Meters List</label>
                    <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                      <input
                        type="text"
                        placeholder="Search meters..."
                        value={searchMeter}
                        onChange={handlemeterSearchChange}
                        style={{ padding: '5px', marginBottom: '10px', width: '90%', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                      {filteredMeter.map((meter, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                          <div>
                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                          </div>
                          <button
                            onClick={() => handleAddMeter(meter)}
                            disabled={addedMeters.some(m => m.meter_id === meter.meter_id)}
                            style={{
                              background: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'gray' : 'green',
                              color: 'white',
                              border: 'none',
                              borderRadius: '5px',
                              padding: '5px',
                              cursor: addedMeters.some(m => m.meter_id === meter.meter_id) ? 'not-allowed' : 'pointer',
                              fontSize: '10px',
                            }}
                          >
                            {addedMeters.some(m => m.meter_id === meter.meter_id) ? 'Added' : 'Add'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{ flex: '1' }}>
                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Meters</label>
                    <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                      {addedMeters.map((meter, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                          <div>
                            <span style={{ fontSize: '12px', display: 'block' }}>{meter.meter_name} - {meter.meter_id}</span>
                          </div>
                          <button
                            onClick={() => handleRemoveMeter(meter.meter_id)}
                            style={{
                              background: 'red',
                              color: 'white',
                              border: 'none',
                              borderRadius: '5px',
                              padding: '5px',
                              cursor: 'pointer',
                              fontSize: '10px',
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
                  <div style={{ flex: '1' }}>
                    <label htmlFor="meters" style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Products List</label>
                    <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                      <input
                        type="text"
                        placeholder="Search products..."
                        value={searchProduct}
                        onChange={handleProductSearchChange}
                        style={{ padding: '5px', marginBottom: '10px', width: '90%', border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                      {filteredProducts.map((product, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                          <div>
                            <span style={{ fontSize: '12px', display: 'block' }}>{product.product_name} - {product.product_id}</span>
                          </div>
                          <button
                            onClick={() => handleAddProduct(product)}
                            disabled={addedProducts.some(p => p.id === product.id)}
                            style={{
                              background: addedProducts.some(p => p.id === product.id) ? 'gray' : 'green',
                              color: 'white',
                              border: 'none',
                              borderRadius: '5px',
                              padding: '5px',
                              cursor: addedProducts.some(p => p.id === product.id) ? 'not-allowed' : 'pointer',
                              fontSize: '10px',
                            }}
                          >
                            {addedProducts.some(p => p.id === product.id) ? 'Added' : 'Add'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{ flex: '1' }}>
                    <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Products</label>
                    <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                      {addedProducts.map((product, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px', backgroundColor: '#f9f9f9', padding: '5px', borderRadius: '4px' }}>
                          <div>
                            <span style={{ fontSize: '12px', display: 'block' }}>{product.product_name} - {product.product_id}</span>
                          </div>
                          <button
                            onClick={() => handleRemoveProduct(product.id)}
                            style={{
                              background: 'red',
                              color: 'white',
                              border: 'none',
                              borderRadius: '5px',
                              padding: '5px',
                              cursor: 'pointer',
                              fontSize: '10px',
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '10px', width: '100%' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                {addedProducts.map((product, index) => (
                  <div
                    key={product.id}
                    style={{
                      flex: '1 0 calc(50% - 10px)',
                      minWidth: '200px',
                      marginBottom: '15px'
                    }}
                  >
                    <h5 style={{ marginBottom: '5px' }}>{product.product_name} Target</h5>
                    <input
                      type="number"
                      value={productTargets[product.id] || ''}
                      onChange={(e) => handleProductTargetChange(product.id, e.target.value)}
                      placeholder={`Enter target for ${product.product_name}`}
                      style={{
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        width: '95%',
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                  User Select
                </label>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    backgroundColor: '#f9f9f9',
                    height: '150px',
                    overflowY: 'auto',
                    position: 'relative',
                  }}
                >
                  <input
                    type="text"
                    value={addsearchTerm}
                    onChange={(e) => setAddSearchTerm(e.target.value)}
                    placeholder="Search users..."
                    style={{
                      padding: '8px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      marginBottom: '10px',
                      width: '90%',
                    }}
                  />

                  <div>
                    {filteredUsers.map(([userId, username]) => {
                      const isUserAdded = userList.includes(userId);
                      return (
                        <div
                          key={userId}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            backgroundColor: '#e0e0e0',
                            alignItems: 'center',
                            padding: '5px',
                            borderRadius: '5px',
                            marginBottom: '8px',
                            fontSize: '12px',
                          }}
                        >
                          <span style={{ color: isUserAdded ? 'gray' : 'black' }}>{username}</span>
                          <button
                            onClick={() => handleAddUser(userId)}
                            style={{
                              backgroundColor: isUserAdded ? 'gray' : '#4CAF50',
                              color: 'white',
                              border: 'none',
                              padding: '5px 10px',
                              borderRadius: '5px',
                              cursor: isUserAdded ? 'not-allowed' : 'pointer',
                              fontSize: '10px',
                              marginLeft: '10px',
                            }}
                            disabled={isUserAdded}
                          >
                            {isUserAdded ? 'Added' : 'Add'}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div style={{ width: '48%' }}>
                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                  Added Users
                </label>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    backgroundColor: '#f9f9f9',
                    height: '150px',
                    overflowY: 'auto',
                  }}
                >
                  {userList.map(userId => (
                    <div
                      key={userId}
                      style={{
                        backgroundColor: '#e0e0e0',
                        marginBottom: '5px',
                        padding: '2px',
                        borderRadius: '3px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '12px'
                      }}
                    >
                      <span>{usersData[userId]}</span>
                      <button
                        onClick={() => handleRemoveUser(userId)}
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          border: 'none',
                          padding: '5px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontSize: '10px'
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '10px 15px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              width: '310px',
              marginLeft: '120px'
            }}>
              <span style={{
                fontWeight: 'bold',
                marginRight: '10px',
                minWidth: '100px'
              }}>Energy Source :</span>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '25px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="dieselCheckbox"
                    checked={newMachine.diesel || false}
                    onChange={(e) => setNewMachine({...newMachine, diesel: e.target.checked})}
                    style={{
                      marginRight: '10px',
                      width: '16px',
                      height: '16px',
                      cursor: 'pointer'
                    }}
                  />
                  <label
                    htmlFor="dieselCheckbox"
                    style={{
                      textTransform: 'capitalize',
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                  >
                    Diesel
                  </label>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="lpgCheckbox"
                    checked={newMachine.lpg || false}
                    onChange={(e) => setNewMachine({...newMachine, lpg: e.target.checked})}
                    style={{
                      marginRight: '10px',
                      width: '16px',
                      height: '16px',
                      cursor: 'pointer'
                    }}
                  />
                  <label
                    htmlFor="lpgCheckbox"
                    style={{
                      textTransform: 'capitalize',
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                  >
                    LPG
                  </label>
                </div>
              </div>
            </div>
            {newMachine.diesel && (
              <div style={{
                backgroundColor: '#f5f5f5',
                padding: '10px 15px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginBottom: '15px',
                width: '310px',
                marginLeft: '120px'
              }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
                  Diesel Target (Liters):
                </label>
                <input
                  type="number"
                  value={newMachine.target_diesel || ''}
                  onChange={(e) => setNewMachine({ ...newMachine, target_diesel: parseFloat(e.target.value) || 0 })}
                  placeholder="Enter target diesel consumption"
                  style={{
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '90%',
                    marginTop: '5px'
                  }}
                  step="0.1"
                  min="0"
                />
              </div>
            )}
            {newMachine.lpg && (
              <div style={{
                backgroundColor: '#f5f5f5',
                padding: '10px 15px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginBottom: '15px',
                width: '310px',
                marginLeft: '120px'
              }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
                  LPG Target (kg):
                </label>
                <input
                  type="number"
                  value={newMachine.target_lpg || ''}
                  onChange={(e) => setNewMachine({ ...newMachine, target_lpg: parseFloat(e.target.value) || 0 })}
                  placeholder="Enter target LPG consumption"
                  style={{
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '90%',
                    marginTop: '5px'
                  }}
                  step="0.1"
                  min="0"
                />
              </div>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  Choose Group Color
                </label>
              </div>
              {validationMessages.color && (
                <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.color}</div>
              )}
              <div
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  background: '#f9f9f9',
                  borderRadius: '8px',
                  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                  width: '500px',
                  maxWidth: '50%',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginLeft: '30px'
                }}
              >
                <ChromePicker
                  color={newMachine.color}
                  onChangeComplete={(color) => setNewMachine({ ...newMachine, color: color.hex })}
                  disableAlpha
                  styles={{
                    default: {
                      picker: {
                        width: '100%'
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
                width: '40%',
                marginLeft: '200px',
              }}
            >
              <button
                onClick={handleAddMachine}
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 15px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  flex: '1',
                  marginRight: '10px',
                }}
              >
                Add Machine
              </button>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '10px 15px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  flex: '1',
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}



      {isEditModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            ref={editMachineModalRef}
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              width: '60%',
              maxWidth: '600px',
              height: '480px',
              transition: 'all 0.3s ease',
              overflowX: 'auto'
            }}
          >
            <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Edit Department</h4>
            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      Department Name <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={editMachine.machine_name}
                      onChange={(e) => setEditMachine({ ...editMachine, machine_name: e.target.value })}
                      style={{
                        flex: '1',
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                      }}
                    />
                    {validationMessages.machine_name && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.machine_name}</div>
                    )}
                  </div>

                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      Department ID <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={editMachine.machine_id}
                      onChange={(e) => setEditMachine({ ...editMachine, machine_id: e.target.value })}
                      style={{
                        flex: '1',
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                      }}
                    />
                    {validationMessages.machine_id && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.machine_id}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      From Time <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="time"
                      value={editMachine.from_time || ''}
                      onChange={(e) => handleEditTimeChange('from', e.target.value)}
                      step="60"
                      style={inputStyle}
                      pattern="[0-9]{2}:[0-9]{2}"
                    />
                    {validationMessages.from_time && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.from_time}</div>
                    )}
                  </div>

                  <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <label>
                      To Time <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="time"
                      value={editMachine.to_time || ''}
                      onChange={(e) => handleEditTimeChange('to', e.target.value)}
                      step="60"
                      style={inputStyle}
                      pattern="[0-9]{2}:[0-9]{2}"
                    />
                    {validationMessages.to_time && (
                      <div style={{ color: 'red', fontSize: '12px' }}>{validationMessages.to_time}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '30px' }}>
              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Meters List</label>
                <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                  <input
                    type="text"
                    value={searchEditMeter}
                    onChange={handleMeterSearchChange}
                    placeholder="Search meters"
                    style={{
                      padding: '5px',
                      marginBottom: '10px',
                      width: '90%',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                    }}
                  />
                  {filteredMeters.map((meter) => (
                    <div
                      key={meter.id}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '5px',
                        backgroundColor: '#f9f9f9',
                        padding: '5px',
                        borderRadius: '4px',
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>{meter.meter_id} - {meter.meter_name}</span>
                      <button
                        onClick={() => addMeter(meter.id)}
                        style={{
                          background: editMachine.meter_list.includes(meter.id) ? 'gray' : 'green',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          padding: '5px',
                          cursor: editMachine.meter_list.includes(meter.id) ? 'not-allowed' : 'pointer',
                          fontSize: '10px',
                        }}
                        disabled={editMachine.meter_list.includes(meter.id)}
                      >
                        {editMachine.meter_list.includes(meter.id) ? 'Added' : 'Add'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Meters</label>
                <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                  {editMachine.meter_list.map((meterId, index) => (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '5px',
                        backgroundColor: '#f9f9f9',
                        padding: '5px',
                        borderRadius: '4px',
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>
                        {meters.find((m) => m.id === meterId)?.meter_id || meterId} - {meters.find((m) => m.id === meterId)?.meter_name || meterId}
                      </span>
                      <button
                        onClick={() => {
                          setEditMachine({
                            ...editMachine,
                            meter_list: editMachine.meter_list.filter((id) => id !== meterId),
                          });
                        }}
                        style={{
                          background: 'red',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          padding: '5px',
                          cursor: 'pointer',
                          fontSize: '10px',
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '30px', marginTop: '20px' }}>
              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Products List</label>
                <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                  <input
                    type="text"
                    value={searchEditProduct}
                    onChange={(e) => setSearchEditProduct(e.target.value)}
                    placeholder="Search products"
                    style={{
                      padding: '5px',
                      marginBottom: '10px',
                      width: '90%',
                      borderRadius: '4px',
                      border: '1px solid #ccc',
                    }}
                  />
                  {filteredEditProducts.map((product) => (
                    <div
                      key={product.id}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '5px',
                        backgroundColor: '#f9f9f9',
                        padding: '5px',
                        borderRadius: '4px',
                      }}
                    >
                      <span style={{ fontSize: '12px' }}>{product.product_id} - {product.product_name}</span>
                      <button
                        onClick={() => {
                          if (!editMachine.product_list.includes(product.id)) {
                            setEditMachine({
                              ...editMachine,
                              product_list: [...editMachine.product_list, product.id]
                            });
                          }
                        }}
                        style={{
                          background: editMachine.product_list.includes(product.id) ? 'gray' : 'green',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          padding: '5px',
                          cursor: editMachine.product_list.includes(product.id) ? 'not-allowed' : 'pointer',
                          fontSize: '10px',
                        }}
                        disabled={editMachine.product_list.includes(product.id)}
                      >
                        {editMachine.product_list.includes(product.id) ? 'Added' : 'Add'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>Added Products</label>
                <div style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', height: '150px', overflowY: 'auto' }}>
                  {editMachine.product_list.map((productId, index) => {
                    const product = products.find(p => p.id === productId);
                    return product ? (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '5px',
                          backgroundColor: '#f9f9f9',
                          padding: '5px',
                          borderRadius: '4px',
                        }}
                      >
                        <span style={{ fontSize: '12px' }}>
                          {product.product_id} - {product.product_name}
                        </span>
                        <button
                          onClick={() => {
                            const product = products.find(p => p.id === productId);
                            setEditMachine(prev => {
                              const newTargets = { ...prev.targets };
                              delete newTargets[product.product_name];
                              return {
                                ...prev,
                                product_list: prev.product_list.filter(id => id !== productId),
                                targets: newTargets
                              };
                            });
                          }}
                          style={{
                            background: 'red',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '5px',
                            cursor: 'pointer',
                            fontSize: '10px',
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            </div>
            <div style={{ marginTop: '10px', width: '100%' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                {editMachine.product_list.map((productId) => {
                  const product = products.find(p => p.id === productId);
                  if (!product) return null;

                  const targetValue = editMachine.targets?.[product.product_name] || '';

                  return (
                    <div
                      key={product.id}
                      style={{
                        flex: '1 0 calc(50% - 10px)',
                        minWidth: '200px',
                        marginBottom: '15px'
                      }}
                    >
                      <h5 style={{ marginBottom: '5px' }}>{product.product_name} Target</h5>
                      <input
                        type="number"
                        value={targetValue}
                        onChange={(e) => {
                          setEditMachine(prev => ({
                            ...prev,
                            targets: {
                              ...prev.targets,
                              [product.product_name]: e.target.value
                            }
                          }));
                        }}
                        placeholder={`Enter target for ${product.product_name}`}
                        style={{
                          padding: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          width: '95%',
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '10px' }}>
              <div style={{ flex: '1' }}>
                <label style={{ marginBottom: '5px', display: 'block', fontWeight: 'bold' }}>
                  User Select
                </label>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f9f9f9',
                  height: '150px',
                  overflowY: 'auto',
                }}>
                  <input
                    type="text"
                    value={editsearchTerm}
                    onChange={(e) => setEditSearchTerm(e.target.value)}
                    placeholder="Search users..."
                    style={{
                      padding: '8px',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                      marginBottom: '10px',
                      width: '90%',
                    }}
                  />
                  <div>
                    {filterededitUsers.map(([userId, username]) => {
                      const isAdded = userList.includes(parseInt(userId));
                      return (
                        <div
                          key={userId}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '8px',
                            backgroundColor: '#e0e0e0',
                            padding: '5px',
                            borderRadius: '5px',
                            fontSize: '12px',
                          }}
                        >
                          <span style={{ color: isAdded ? 'gray' : 'black' }}>{username}</span>
                          <button
                            onClick={() => handleAddUser(parseInt(userId))}
                            style={{
                              backgroundColor: isAdded ? 'gray' : '#4CAF50',
                              color: 'white',
                              border: 'none',
                              padding: '5px 10px',
                              borderRadius: '5px',
                              cursor: isAdded ? 'not-allowed' : 'pointer',
                              fontSize: '10px',
                              marginLeft: '10px',
                            }}
                            disabled={isAdded}
                          >
                            {isAdded ? 'Added' : 'Add'}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div style={{ width: '48%' }}>
                <label style={{ marginBottom: '8px', display: 'block', fontWeight: 'bold' }}>
                  Added Users
                </label>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    backgroundColor: '#f9f9f9',
                    height: '150px',
                    overflowY: 'auto',
                  }}
                >
                  {userList.map(userId => (
                    <div
                      key={userId}
                      style={{
                        backgroundColor: '#e0e0e0',
                        marginBottom: '5px',
                        padding: '2px',
                        borderRadius: '3px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '12px'
                      }}
                    >
                      <span>{usersData[userId]}</span>
                      <button
                        onClick={() => handleRemoveUser(userId)}
                        style={{
                          backgroundColor: 'red',
                          color: 'white',
                          border: 'none',
                          padding: '5px',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontSize: '10px'
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '10px 15px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              marginBottom: '15px',
              display: 'flex',
              alignItems: 'center',
              width: '310px',
              marginLeft: '120px'
            }}>
              <span style={{
                fontWeight: 'bold',
                marginRight: '10px',
                minWidth: '100px'
              }}>Energy Source :</span>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '25px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="dieselCheckbox"
                    checked={editMachine.diesel || false}
                    onChange={(e) => setEditMachine({...editMachine, diesel: e.target.checked})}
                    style={{
                      marginRight: '10px',
                      width: '16px',
                      height: '16px',
                      cursor: 'pointer'
                    }}
                  />
                  <label
                    htmlFor="dieselCheckbox"
                    style={{
                      textTransform: 'capitalize',
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                  >
                    Diesel
                  </label>
                </div>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="lpgCheckbox"
                    checked={editMachine.lpg || false}
                    onChange={(e) => setEditMachine({...editMachine, lpg: e.target.checked})}
                    style={{
                      marginRight: '10px',
                      width: '16px',
                      height: '16px',
                      cursor: 'pointer'
                    }}
                  />
                  <label
                    htmlFor="lpgCheckbox"
                    style={{
                      textTransform: 'capitalize',
                      cursor: 'pointer',
                      userSelect: 'none'
                    }}
                  >
                    LPG
                  </label>
                </div>
              </div>
            </div>
            {editMachine.diesel && (
              <div style={{
                backgroundColor: '#f5f5f5',
                padding: '10px 15px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginBottom: '15px',
                width: '310px',
                marginLeft: '120px'
              }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
                  Diesel Target (Liters):
                </label>
                <input
                  type="number"
                  value={editMachine.target_diesel || ''}
                  onChange={(e) => setEditMachine({ ...editMachine, target_diesel: parseFloat(e.target.value) || 0 })}
                  placeholder="Enter target diesel consumption"
                  style={{
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '90%',
                    marginTop: '5px'
                  }}
                  step="0.1"
                  min="0"
                />
              </div>
            )}

            {editMachine.lpg && (
              <div style={{
                backgroundColor: '#f5f5f5',
                padding: '10px 15px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginBottom: '15px',
                width: '310px',
                marginLeft: '120px'
              }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
                  LPG Target (kg):
                </label>
                <input
                  type="number"
                  value={editMachine.target_lpg || ''}
                  onChange={(e) => setEditMachine({ ...editMachine, target_lpg: parseFloat(e.target.value) || 0 })}
                  placeholder="Enter target LPG consumption"
                  style={{
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '90%',
                    marginTop: '5px'
                  }}
                  step="0.1"
                  min="0"
                />
              </div>
            )}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  Edit Group Color
                </label>
              </div>
              <div
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  background: '#f9f9f9',
                  borderRadius: '8px',
                  boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                  width: '500px',
                  maxWidth: '50%',
                  marginBottom: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginLeft: '30px'
                }}
              >
                <ChromePicker
                  color={editMachine.color}
                  onChangeComplete={(colors) => setEditMachine({ ...editMachine, color: colors.hex })}
                  disableAlpha
                  styles={{
                    default: {
                      picker: {
                        width: '100%'
                      },
                    },
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '20px',
                width: '40%',
                marginLeft: '200px',
              }}
            >
              <button
                onClick={handleEditMachine}
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 10px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  flex: '1',
                  marginRight: '10px',
                }}
              >
                Save Changes
              </button>
              <button
                onClick={() => setEditModalOpen(false)}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '10px 10px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  flex: '1',
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            ref={deleteModalRef}
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              width: "400px",
              textAlign: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete the selected machines?</p>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  style={{
                    padding: "10px 15px",
                    color: "white",
                    backgroundColor: "#4CAF50",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={handleDeleteMachines}
                >
                  Yes, Delete
                </button>
                <button
                  style={{
                    padding: "10px 15px",
                    color: "white",
                    backgroundColor: "#f44336",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={() => setDeleteModalOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default MachineList;
